/* eslint-disable react-refresh/only-export-components */
import { ColumnHelper } from "@tanstack/react-table";
import { ManageRolesTableDataItem } from "PFApp/activities/manage_roles/manage_roles.types";
import { RolesFormKey } from "PFApp/types/activity_form/activity_form_schema";
import { ManageRolesMultiForm } from "PFApp/types/activity_form/manage_roles_form_schema";
import { RoleStatusBadge } from "PFComponents/role/role_status_badge";
import { ActivityState } from "PFCore/types";
import { useWatch } from "react-hook-form";

import css from "./cell.module.scss";

const STATE_COLUMN_WIDTH = 100;

type StateCellProps = {
  rolesFormKey: RolesFormKey;
  rowIndex: number;
};

const StateCell = ({ rolesFormKey, rowIndex }: StateCellProps) => {
  const name = `${rolesFormKey}.${rowIndex}.state` as const;
  const state = useWatch<ManageRolesMultiForm>({ name }) as ActivityState | undefined;

  return (
    <div className={css.cell}>
      <RoleStatusBadge state={state} />
    </div>
  );
};

export const createStateColumn = (
  columnHelper: ColumnHelper<ManageRolesTableDataItem>,
  rolesFormKey: RolesFormKey,
  headerLabel: string
) =>
  columnHelper.accessor((row) => row, {
    id: "state",
    header: () => <span>{headerLabel}</span>,
    cell: (info) => <StateCell rolesFormKey={rolesFormKey} rowIndex={info.row.index} />,
    size: STATE_COLUMN_WIDTH,
    meta: {
      getIsCopyPasteBlocked: () => true
    }
  });
